import { useRef, useState, useEffect } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Stack,
  TextField,
  Container,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
  Button
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { toast } from 'react-toastify';

import UploadPreview from '../components/uploads/UploadPreview';
import Page from '../components/Page';
import { newWork, getWork, updateWork } from '../utils/requests/workRequest';

export default function AddProject() {
  const navigate = useNavigate();

  const titleInput = useRef();
  const companyInput = useRef();

  const [file, setFile] = useState();

  const [photo, setPhoto] = useState();

  const [titleError, setTitleError] = useState(false);
  const [companyError, setCompanyError] = useState(false);

  const [isSend, setIsSend] = useState(false);

  const { id } = useParams();

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      remember: true
    },
    onSubmit: () => {}
  });

  function onFileChange(e) {
    setFile(e.target.files[0]);
  }

  useEffect(() => {
    if (!id) return;
    getWork(id).then((work) => {
      titleInput.current.value = work.title;
      companyInput.current.value = work.details;
      setPhoto(work.gallery.url);
    });
  }, [id]);

  function onSubmit(e) {
    e.preventDefault();
    const title = titleInput.current.value;
    const company = companyInput.current.value;

    setTitleError(false);
    setCompanyError(false);

    setIsSend(true);

    let work;
    if (id) {
      work = updateWork(id, title, company, file, 1);
    } else {
      work = newWork(title, company, file, 1);
    }

    work
      .then((response) => {
        toast.success(response.data.message);
        navigate('../');
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
          const { data } = error.response;
          if (data.data.title) {
            setTitleError(data.data.title[0]);
          }
          if (data.data.details) {
            setCompanyError(data.data.details[0]);
          }
          if (data.data.file) {
            toast.error(data.data.file[0]);
          }
        }
      })
      .finally(() => {
        setIsSend(false);
      });
  }

  function navigateProjectsList() {
    navigate('../');
  }

  return (
    <Page>
      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Add new project
        </Typography>
        <FormikProvider value={formik} onSubmit={(e) => onSubmit(e)}>
          <Form autoComplete="off" noValidate onSubmit={(e) => onSubmit(e)}>
            <Stack spacing={3}>
              <Stack style={{ width: '100%' }} spacing={5} direction={{ xs: 'column', sm: 'row' }}>
                <Stack style={{ width: '100%' }}>
                  <Typography>File</Typography>
                  <UploadPreview
                    currentPhoto={photo}
                    onChange={(e) => onFileChange(e)}
                    style={{ width: '100%' }}
                  />
                </Stack>
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  error={titleError}
                  disabled={isSend}
                  helperText={titleError}
                  fullWidth
                  type="text"
                  label="Project title"
                  inputRef={titleInput}
                />
                <TextField
                  error={companyError}
                  helperText={companyError}
                  fullWidth
                  disabled={isSend}
                  type="text"
                  label="Company"
                  inputRef={companyInput}
                />
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <LoadingButton loading={isSend} variant="contained" type="submit">
                  Create
                </LoadingButton>
                <Button disabled={isSend} variant="text" onClick={() => navigateProjectsList()}>
                  Cancel
                </Button>
              </Stack>
            </Stack>
          </Form>
        </FormikProvider>
      </Container>
    </Page>
  );
}
